export default "/images/vendor/@coreui/icons/svg/flag/cif-se.svg?9be3e90e1baf8589693c870197f06d28";